import React from 'react';
import { Switch, Route, Redirect, withRouter } from 'react-router';
import { Login, route as LoginRoute } from '../LoginView';
import { route as AuthRoute } from '../Auth';
import { route as SSO } from '../SSO';
import { route as Kerberos } from '../Kerberos';
import '../../styles/styles.scss';

const LoginWithRoute = withRouter(Login);

const App = () => (
  <Switch>
    <Route path={LoginRoute.path} component={LoginWithRoute} />
    <Route path={AuthRoute.path} component={AuthRoute.component} />
    <Route path={SSO.path} component={SSO.component} />
    <Route path={Kerberos.path} component={Kerberos.component} />
    <Redirect to={AuthRoute.path} />
  </Switch>
);

const route = {
  path: '/',
  component: App
};

// eslint-disable-next-line no-restricted-exports
export { App as default, App as LoginSite, route };